import { X } from "lucide-react";
import { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";

import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";

interface DebouncedInputProps extends Omit<
  React.InputHTMLAttributes<HTMLInputElement>,
  "onChange"
> {
  value: string;
  onChange: (value: string) => void;
  debounce?: number;
}

/**
 * Matn filtri.
 *
 * Har bosishda so'rov yubormaydi: 400 ms jim turgandan keyin bir marta.
 * Busiz "Nuriddinov" so'zi 11 ta so'rov qilardi va oxirgisidan boshqasi
 * baribir tashlab yuborilardi.
 */
export function DebouncedInput({
  value: initialValue,
  onChange,
  debounce = 400,
  ...props
}: Readonly<DebouncedInputProps>) {
  const { t } = useTranslation();
  const [value, setValue] = useState(initialValue);
  const [previous, setPrevious] = useState(initialValue);
  const inputRef = useRef<HTMLInputElement>(null);

  // Tashqi qiymat o'zgarsa (masalan "Tozalash" bosilsa) ichkarisi ham
  // yangilanadi. Render paytida `setState` — React renderni darhol
  // yangi holat bilan qayta boshlaydi, qo'shimcha render bo'lmaydi.
  if (previous !== initialValue) {
    setPrevious(initialValue);
    setValue(initialValue);
  }

  useEffect(() => {
    const timeout = setTimeout(() => onChange(value), debounce);
    return () => clearTimeout(timeout);
  }, [value, onChange, debounce]);

  // Filtr oynasi ochilishining yagona sababi — yozish.
  useEffect(() => {
    inputRef.current?.focus();
  }, []);

  return (
    <div className="relative">
      <Input
        ref={inputRef}
        {...props}
        value={value}
        onChange={event => setValue(event.target.value)}
        className="w-64 border-none shadow-none focus-visible:ring-[1px]"
      />
      {value && (
        <Button
          type="button"
          size="icon"
          variant="ghost"
          className="bg-accent absolute top-1 right-1 size-7"
          aria-label={t("common.reset")}
          onClick={() => setValue("")}
        >
          <X className="size-4" />
        </Button>
      )}
    </div>
  );
}
